import { ApiConfig, Command, CommandHandler, ConsoleLogger, HttpService, TaggedUrl, Tags } from '@skylab-shared/core';
import { FileMode } from '@skylab-shared/dataModel';
import { downloadFileDirectly, fillPlaceholders } from '@skylab-shared/utils';

export interface DocumentDownloadFileMultiCommandParams {
    documentIds: number[];
    config: {
        password?: string;
        compress?: boolean;
        duplicate?: boolean;
        dateOfDuplicate?: Date;
        mode: FileMode;
    };
}

export type DocumentDownloadFileMultiCommandResult = void;

export class DocumentDownloadFileMultiCommand extends Command<DocumentDownloadFileMultiCommandParams, DocumentDownloadFileMultiCommandResult> { }

export class DocumentDownloadFileMultiCommandHandlerBase implements CommandHandler<DocumentDownloadFileMultiCommand, DocumentDownloadFileMultiCommandParams, DocumentDownloadFileMultiCommandResult> {
    private static Url = TaggedUrl.join('documents/batch/printing?:ids', [Tags.Api]);
    private logger: ConsoleLogger;

    public constructor(
        private readonly http: HttpService
    ) {
        this.logger = new ConsoleLogger(this.constructor.name);
    }

    public async handleAsync({ params }: DocumentDownloadFileMultiCommand): Promise<DocumentDownloadFileMultiCommandResult> {
        const newWindow = !params?.config.compress ? window.open('about:blank', '_blank') : window;
        if (newWindow && params) {
            if (!params.config.compress) {
                newWindow.document.write('Ładowanie pliku pdf...');
                newWindow.blur();
            }
            try {
                const { data } = await this.http.post(fillPlaceholders(DocumentDownloadFileMultiCommandHandlerBase.Url, { ids: `ids=${params.documentIds.join(`&ids=`)}` }), { ...params.config });

                const targetUrl = `${ApiConfig.baseUrl}${data.url}`;
                if (!params.config.compress) {
                    //#region show new window with pdf
                    newWindow.location.href = targetUrl;
                    newWindow.focus();
                    //#endregion
                } else {
                    //#region direct download pdf
                    downloadFileDirectly(targetUrl);
                    //#endregion
                }
            } catch (err) {
                newWindow.close();
                this.logger.error(err);
                throw err;
            }
        }
    }
}
